import { CognitoUser } from "amazon-cognito-identity-js";
import { userPool } from "../aws";

const AwsResetOtp = (email, callback=(error, msg)=>{}) => {
    let userData = { Username: email, Pool: userPool, };

    let cognitoUser = new CognitoUser(userData);

    cognitoUser.resendConfirmationCode(function(err, result) {
        if (err) {
            // toastMessage(err.message || JSON.stringify(err), "error");
            callback(err.message, null);
            return;
        }
        console.log('call result: ' + result);
        callback(null, "OTP has been send");
        // toastMessage("OTP has been resend", "success");
    });
}

export default AwsResetOtp;